/**
 * Alaska: App.js (PWA)
 * Data: Account
 * @version 1.0
 */
document.addEventListener("alpine:init", () => {
    Alpine.data("Account", () => ({
        name: Alpine.store("user").driver.full_name,
        phone: Alpine.store("user").driver.phone,
        company: Alpine.store("user").company.name,

        async submit_changes() {
            try {
                const res = await fetch("/", {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        action: "update",
                        controller: "account",
                        data: {
                            name: this.name,
                            phone: this.phone,
                            company: this.company,
                            email: Alpine.store("user").driver.email,
                        }
                    })
                });

                const json = await res.json();
                Alpine.store("overlay").render(json.type, json.message);
            } catch (err) {
                console.error("Auth check failed:", err);
            }
        }
    }));
});
